/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useForm } from 'react-hook-form';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';
import bgimg from '../../assets/images/bgimg4.jpg';
import inetlogo from '../../assets/images/inetlogo.png';
import { PassportAuth } from '../../contexts/AuthContext';

import Swal from 'sweetalert2';

function Login() {
  useEffect(() => {
    const expired = localStorage.getItem('sessionExpired');
    if (expired) {
      localStorage.removeItem('sessionExpired');
      Swal.fire({
        icon: 'warning',
        title: 'หมดเวลาใช้งาน',
        text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
        confirmButtonText: 'ตกลง',
        allowOutsideClick: false,
      });
    }
  }, []);

  const { handleSignin } = useContext(PassportAuth);
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await handleSignin(data.email, data.password);
      navigate('/');
    } catch (error) {
      console.error(error);
      alert('เข้าสู่ระบบไม่สำเร็จ');
      setIsLoading(false);
    }
  };

  return getStorage('token') ? (
    <Navigate to="/" />
  ) : (
    <div
      style={{
        backgroundImage: `url(${bgimg})`,
        backgroundSize: 'cover',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container component="main" maxWidth="lg">
        <Loading isLoading={isLoading} />
        <CssBaseline />
        <div className="flex h-screen">
          <div className="m-auto">
            <div
              className="sm:min-w-full md:w-1/2 lg:w-full"
              style={{ borderRadius: '50px', backgroundColor: '#0F4898' }}
            >
              <div>
                <Box
                  sx={{
                    paddingLeft: 3,
                    paddingRight: 3,
                    paddingBottom: 4,
                    paddingTop: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src={inetlogo}
                    alt="INET Logo"
                    sx={{
                      height: 80,
                      marginBottom: 2,
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: '22px',
                      fontWeight: 'bold',
                      color: '#fff',
                    }}
                  >
                    LOGIN
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '18px',
                      marginBottom: '15px',
                      color: '#fff',
                    }}
                  >
                    User of INET e-payment
                  </Typography>

                  <Box noValidate sx={{ mt: 4 }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <PersonIcon
                          sx={{
                            fontSize: 38,
                            color: '#fff',
                            paddingRight: '5px',
                          }}
                        />
                        <TextField
                          required
                          id="email"
                          placeholder="Email Address"
                          {...register('email')}
                          name="email"
                          autoComplete="email"
                          size="small"
                          sx={{
                            width: '265px',
                            marginLeft: '8px',
                            backgroundColor: '#fff',
                            borderRadius: '5px',
                            fontSize: '12px',
                          }}
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <LockIcon
                          sx={{
                            fontSize: 38,
                            color: '#fff',
                            paddingRight: '5px',
                          }}
                        />
                        <TextField
                          margin="normal"
                          required
                          name="password"
                          placeholder="Password"
                          {...register('password')}
                          type="password"
                          id="password"
                          autoComplete="current-password"
                          size="small"
                          sx={{
                            width: '265px',
                            marginLeft: '8px',
                            backgroundColor: '#fff',
                            borderRadius: '5px',
                          }}
                        />
                      </Box>
                      <Button
                        loading={isLoading}
                        type="submit"
                        variant="contained"
                        sx={{
                          mt: 3,
                          mb: 2,
                          width: '200px',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          display: 'block',
                          borderRadius: '12px',
                          marginBottom: '50px',
                          backgroundColor: '#4E91EE',
                          fontSize: '15px',
                        }}
                      >
                        <div
                          className="text-white"
                          style={{
                            display: 'inline-block',
                          }}
                        >
                          Login
                        </div>
                      </Button>
                    </form>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%', // ใช้ถ้าต้องการให้เนื้อหาอยู่กึ่งกลางแนวตั้งด้วย
                        }}
                      >
                        <Link
                          href="https://one.th/type_forgot_password"
                          variant="body2"
                          style={{ color: '#fff', fontSize: '14px' }}
                        >
                          Forgot password?
                        </Link>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%', // ใช้ถ้าต้องการให้เนื้อหาอยู่กึ่งกลางแนวตั้งด้วย
                        }}
                      >
                        <Link
                          href="https://one.th/register"
                          variant="body2"
                          style={{
                            color: '#fff',
                            fontSize: '14px',
                          }}
                        >
                          Don't have an account? Sign Up
                        </Link>
                      </Box>
                    </Grid>
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Login;
